module.exports = __webpack_public_path__ + "assets/img/404_qq.ad62fc89.svg";